<template>
  <div class="program-list-head" v-if="value">
    <h1>{{$ml.get(`Programs`)}}</h1>
    <div class="buttons">
      <app-btn
        @click="toggleCreateProgramPopup"
        id="create_program_button"
        :disabled="!programs.is_available || value >= programs.max"
      >
        {{ $ml.get(`Add program`) }}
      </app-btn>
    </div>
    <transition name="modal-fade-scale">
      <CreateProgramModal
        v-if="openPopup"
        @close="toggleCreateProgramPopup"
      />
    </transition>
  </div>
  <div class="empty" v-else>
    <empty-content :title="$ml.get(`You don\'t have any programs yet`)">
      <template v-slot:content>
        <app-btn @click="toggleCreateProgramPopup">{{$ml.get(`Add program`)}}</app-btn>
      </template>
    </empty-content>
    <CreateProgramModal
      v-if="openPopup"
      @close="toggleCreateProgramPopup"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateProgramModal from '@/components/program/CreateProgramModal'

export default {
  props: {
    value: {
      required: false,
      default: true,
    }
  },
  data() {
    return {
      openPopup: false,
      disabled: false,
    }
  },
  computed: {
    ...mapGetters({
      programs: 'user/availablePrograms',
    }),
  },
  created() {
    this.$store.dispatch('user/availableReports');
  },
  methods: {


    toggleCreateProgramPopup() {
      this.openPopup ^= true;
    },
  },
  components: {
    CreateProgramModal,
  },
}
</script>

<style lang="scss" scoped>

.program-list-head {

  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
    h1 {
      margin-top: 0;
      margin-bottom: 16px;
    }
  }
}

</style>
